var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1663 27.6663V4.66634C39.1663 2.55801 37.4413 0.833008 35.333 0.833008H12.333C10.2247 0.833008 8.49967 2.55801 8.49967 4.66634V27.6663C8.49967 29.7747 10.2247 31.4997 12.333 31.4997H35.333C37.4413 31.4997 39.1663 29.7747 39.1663 27.6663ZM18.083 19.9997L21.9738 25.1938L27.6663 18.083L35.333 27.6663H12.333L18.083 19.9997ZM0.833008 8.49967V35.333C0.833008 37.4413 2.55801 39.1663 4.66634 39.1663H31.4997V35.333H4.66634V8.49967H0.833008Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPlaceholder);
export default __webpack_public_path__ + "static/media/project_placeholder.bad62c0c79051b13f878b8be1550f7cb.svg";
export { ForwardRef as ReactComponent };